/** localhost / 127.0.0.0/8 — typisch nur HTTP im Dev */
export function isLocalHostname(hostname) {
  const h = (hostname || '').toLowerCase();
  if (h === 'localhost' || h === '127.0.0.1' || h === '[::1]') return true;
  return /^127\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(h);
}

/**
 * Backend-Root ohne …/api (für …/api/user/…).
 * Ohne Schema: lokale Hosts → http://, sonst https://.
 * https://localhost:PORT (PORT ≠ 443) → http:// (sonst ERR_SSL_PROTOCOL_ERROR gegen cargo run).
 */
export function normalizeBackendApiBase(url) {
  if (!url || typeof url !== 'string' || !url.trim()) return '';
  const raw = url.trim().replace(/\/+$/, '');
  try {
    const hasScheme = /^[a-z][a-z0-9+.-]*:\/\//i.test(raw);
    const hostPart = raw.split('/')[0];
    const hostnameOnly = hostPart.split(':')[0];
    const defaultProto = isLocalHostname(hostnameOnly) ? 'http://' : 'https://';
    const toParse = hasScheme ? raw : `${defaultProto}${raw}`;
    const u = new URL(toParse);
    let path = u.pathname.replace(/\/+$/, '');
    if (path.toLowerCase().endsWith('/api')) {
      path = path.slice(0, -4).replace(/\/+$/, '') || '';
    }
    let protocol = u.protocol;
    if (isLocalHostname(u.hostname) && protocol === 'https:') {
      const p = u.port;
      if (p && p !== '443') {
        protocol = 'http:';
      }
    }
    return `${protocol}//${u.host}${path}`;
  } catch {
    return raw.replace(/\/api\/?$/i, '').replace(/\/+$/, '');
  }
}

/**
 * Prüft, ob nach Normalisierung eine absolute Backend-Basis-URL für fetch vorliegt
 * (verhindert relative Pfade wie „zeitece.example.com/version“ auf der SPA-Origin).
 */
export function isFetchableBackendBase(url) {
  const base = normalizeBackendApiBase(url);
  if (!base) return false;
  try {
    const u = new URL(base);
    if (u.protocol !== 'http:' && u.protocol !== 'https:') return false;
    const host = u.hostname;
    if (!host) return false;
    if (isLocalHostname(host)) return true;
    return host.includes('.');
  } catch {
    return false;
  }
}
